import { EarningsYieldValues, EarningsYieldResult } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

// Earnings Yield (%) = EPS (after tax) / Price per share * 100
export function calculateEarningsYield(values: EarningsYieldValues, t?: ToolsTranslations['earningsYield']): EarningsYieldResult {
  const { pricePerShare, epsAfterTax } = values;
  if (pricePerShare <= 0) return { percent: null, isValid: false, message: t?.invalid.pricePerShare };
  if (epsAfterTax < 0) return { percent: null, isValid: false, message: t?.invalid.epsAfterTax };

  const percent = Math.round((epsAfterTax / pricePerShare) * 1000) / 10; // one decimal e.g., 25.0
  if (!isFinite(percent)) return { percent: null, isValid: false, message: t?.invalid.generic };

  return { percent, isValid: true };
}


